import { Cloud, Sun, CloudRain, Snowflake } from 'lucide-react';
import type { ProgrammingQuote } from './types';

export const WEATHER_CONDITIONS = [
  { icon: Sun, label: 'Sunny', temp: 28, color: 'text-yellow-400' },
  { icon: Cloud, label: 'Cloudy', temp: 22, color: 'text-gray-400' },
  { icon: CloudRain, label: 'Rainy', temp: 18, color: 'text-blue-400' },
  { icon: Snowflake, label: 'Snowy', temp: -2, color: 'text-cyan-300' },
];

export const PROGRAMMING_QUOTES: ProgrammingQuote[] = [
  { text: "Code is like humor. When you have to explain it, it's bad.", author: "Cory House" },
  { text: "First, solve the problem. Then, write the code.", author: "John Johnson" },
  { text: "The best error message is the one that never shows up.", author: "Thomas Fuchs" },
  { text: "Simplicity is the soul of efficiency.", author: "Austin Freeman" },
  { text: "Make it work, make it right, make it fast.", author: "Kent Beck" },
  { text: "Any fool can write code that a computer can understand. Good programmers write code that humans can understand.", author: "Martin Fowler" },
];
